import {
  SET_VALIDATOR,
  SHOW_SNACKBAR,
  RESET_SNACKBAR,
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SET_DISPLAY_USER_CONFIGURATIONS,
  RESET_SYSTEM,
  SET_SERVER_TIME,
  SET_SHOW_DASHBOARD,
  SET_QUEUE_LISTENER_MESSAGE_BROKER,
  UPDATE_PAUSE_ALERTS,
  ADD_ALERT_NOT_READ,
  CLEAN_ALERT_NOT_READ,
  SET_SYSTEM_FILE,
  SET_MENU_SELECTED,
  SET_WHITELABEL,
} from '../../mutation-types';

const mutations = {
  [SET_VALIDATOR](state, validator) {
    state.Validator = validator;
  },

  [SHOW_SNACKBAR](state, options) {
    state.snackbar.text = options.text;
    state.snackbar.display = true;
    if (options.type) {
      state.snackbar.color = options.type;
    }
  },

  [ADD_NOTIFICATION](state, notification) {
    state.notifications.push(notification);
  },

  [REMOVE_NOTIFICATION](state, id) {
    state.notifications = state.notifications.filter((notification) => {
      return notification.id != id;
    });
  },

  [RESET_SNACKBAR](state) {
    state.snackbar.text = '';
    state.snackbar.display = false;
    state.snackbar.color = '';
    state.notifications = [];
  },

  [SET_DISPLAY_USER_CONFIGURATIONS](state, display) {
    state.displayUsersConfigurations = display;
  },

  [RESET_SYSTEM](state) {
    state.notifications = [];
    state.alerts = [];
    state.alertsNotRead = 0;
    state.showDashboard = false;
    state.systemFile = null;
  },

  [SET_SERVER_TIME](state, time) {
    state.serverTime = time;
  },

  [SET_SHOW_DASHBOARD](state, handle) {
    state.showDashboard = handle;
  },
  [SET_QUEUE_LISTENER_MESSAGE_BROKER](state, queueToListen) {
    state.queueListenerMessageBroker = queueToListen;
  },

  [UPDATE_PAUSE_ALERTS](state, params) {
    state.alerts.push(params);
  },

  [ADD_ALERT_NOT_READ](state) {
    state.alertsNotRead += 1;
  },

  [CLEAN_ALERT_NOT_READ](state) {
    state.alertsNotRead = 0;
  },

  [SET_SYSTEM_FILE](state, info) {
    state.systemFile = info;
  },

  [SET_MENU_SELECTED](state, menuSelected) {
    state.menuSelected = menuSelected;
  },

  [SET_WHITELABEL](state, whitelabel) {
    state.whitelabel = whitelabel;
  },
};

export default mutations;
